<template>
  <b-row>
    <b-col sm="12">
      <h3>Loans/Other Debt</h3>
      <p class="text-muted">List any other loans or debt here.</p>
      <b-row>
        <b-col sm="12">
          <b-table v-if="value.loans.length > 0" :small="true" hover :items="value.loans" :fields="fields" @row-clicked="edit" foot-clone>
            <template v-slot:cell(balance)="data">
              <dollars :value="data.value"></dollars>
            </template>
            <template v-slot:cell(minimumPayment)="data">
              <dollars :value="data.value" :postfix="'mo'"></dollars>
            </template>
            <template v-slot:cell(actualPayment)="data">
              <dollars :value="data.value" :postfix="'mo'"></dollars>
            </template>
            <template v-slot:cell(rate)="data">
              <percent :value="data.value"></percent>
            </template>
            <template v-slot:cell(delete)="data">
              <div class="text-right">
                <b-button size="sm" variant="ghost-danger" @click.stop="remove(data.item)"><i class="fa fa-remove"></i></b-button>
              </div>
            </template>
            <template v-slot:foot(name)></template>
            <template v-slot:foot(balance)>
              <dollars :value="totalBalance"></dollars>
            </template>
            <template v-slot:foot(minimumPayment)>
              <dollars :value="totalMinimumPayment" :postfix="'mo'"></dollars>
            </template>
            <template v-slot:foot(actualPayment)>
              <dollars :value="totalActualPayment" :postfix="'mo'"></dollars>
            </template>
            <template v-slot:foot(rate)></template>
            <template v-slot:foot(years)></template>
          </b-table>
          <b-button size="sm" variant="outline-success" @click="add()">
            <i class="fa fa-plus"></i>&nbsp;Add Loan/Debt
          </b-button>
          <loan-modal v-on:save="save"></loan-modal>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import LoanModal from '@/components/modals/LoanModal'
import Dollars from '@/components/text/Dollars'
import Percent from '@/components/text/Percent'

export default {
  props: [ 'clientId', 'value' ],
  components: {
    LoanModal,
    Dollars,
    Percent
  },
  computed: {
    totalBalance: function () {
      let total = 0.0
      this.value.loans.forEach(function(item) { total += parseFloat(item.balance) })
      return total
    },
    totalMinimumPayment: function () {
      let total = 0.0
      this.value.loans.forEach(function(item) { total += parseFloat(item.minimumPayment) })
      return total
    },
    totalActualPayment: function () {
      let total = 0.0
      this.value.loans.forEach(function(item) { total += parseFloat(item.actualPayment) })
      return total
    }
  },
  data () {
    return {
      fields: [
        { key: 'name', label: 'Type' },
        { key: 'balance', class: "numeric" },
        { key: 'minimumPayment', class: 'numeric' },
        { key: 'actualPayment', class: 'numeric' },
        { key: 'rate', class: "numeric" },
        { key: 'years', class: "numeric" },
        { key: 'delete', label: '', class: 'delete' }
      ],
      items: [],
      editing: null
    }
  },
  methods: {
    add () {
      this.$bus.$emit('modal:editLoan')
    },
    edit (item) {
      let index = this.value.loans.indexOf(item)
      this.editing = index
      this.$bus.$emit('modal:editLoan', item)
    },
    remove (item) {
      let token = this.$route.params.token
      this.$api.clients.intake.deleteLoan({ token: token, id: item.id })
        .then(() => {
          this.$emit('update')
          this.$snotify.success('Loan Deleted Successfully')
        })
        .catch((err) => {
          this.$snotify.error('There was a problem removing the policy.')
        })
    },
    save (value) {
      let token = this.$route.params.token
      value.clientId = this.clientId
      if (value.id) {
        this.$api.clients.intake.updateLoan({ token: token, id: value.id }, value)
          .then((response) => {
            this.$emit('update', value)
            this.$snotify.success('Loan Saved Successfully')
          })
          .catch((err) => {
            this.$snotify.error('There was a problem saving the Loan.')
          })
      } else {
        this.$api.clients.intake.createLoan({ token: token }, value)
          .then((response) => {
            this.$emit('update', value)
            this.$snotify.success('Loan Added Successfully')
          })
          .catch((err) => {
            this.$snotify.error('There was a problem saving the Loan.')
          })
      }
    }
  }
}
</script>
